export const incentivePlanRenderer = (value, data, account = {}, config = {}) => {
  const { incentivePlans } = config;
  
  if(value)
  { 
    if(value.length > 4)
    {
      return value;
    }
    else
    {
      const match = incentivePlans.find(r => r.code === value);
      return match ? match.description : '';
    }
  }
    
  
};